import React, { useState } from "react";
import "./CustomAccordion.css";
import AccordionDrop from "../../assets/icons/customaccordion-drop.svg";

const CustomAccordion = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="custaccordion__container">
      <button className="custaccordion__button" onClick={toggleAccordion}>
        <div className="custaccordion__buttonlft">{title}</div>
        <div className="custaccordion__buttonrt">
          <img
            src={AccordionDrop}
            alt=""
            className={`custaccordion__btnrt_drop ${
              isOpen ? "custaccordion__btnrt_dropreverse" : ""
            }`}
          />
        </div>
      </button>
      <div
        className={`custaccordion__content ${isOpen ? "open" : ""}`}
        style={{
          maxHeight: isOpen ? "1000px" : "0",
          opacity: isOpen ? "1" : "0",
          transition: "max-height 0.6s ease-in-out, opacity 0.3s ease-in-out",
        }}
      >
        <div className="custaccordion__contentwrap">{content}</div>
      </div>
    </div>
  );
};

export default CustomAccordion;
